export const combineExportAudienceRuleId = (
  audienceRuleId: number,
  thirdPartyId: number = 0
) => `${audienceRuleId}+${thirdPartyId}`
